// クライアントユーザー管理
import {setupCompanySuggestSelect} from '../../../common/suggests';

$(() => {
    // ユーザー一覧
    if ($('#agent-users').length) {
        setupUsers();
    }
});

// ユーザー一覧
function setupUsers() {
    setupCompanySuggestSelect($('.js-select2'), "POST", "/api/users/findCompany", "agent", function(data) {
        return {
            results: $.map(data, function (item) {
                return {
                    id: item.id,
                    text: item.company_name,
                    place: item.place
                }
            })
        }
    });
}
